import { render, staticRenderFns } from "./PageDisable.vue?vue&type=template&id=24aeeaaf&scoped=true&"
import script from "./PageDisable.vue?vue&type=script&lang=js&"
export * from "./PageDisable.vue?vue&type=script&lang=js&"
import style0 from "./PageDisable.vue?vue&type=style&index=0&id=24aeeaaf&scoped=true&lang=css&"
import style1 from "./PageDisable.vue?vue&type=style&index=1&id=24aeeaaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aeeaaf",
  null
  
)

export default component.exports